import AutoReplenishmentCancelledItem from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishmentCancelledItem/AutoReplenishmentCancelledItem';

export default AutoReplenishmentCancelledItem;
